// extracted by mini-css-extract-plugin
module.exports = {"icona":"icona_icona__nfJKp"};